// ---------------------------------------------------------
// FIX: Safety check to prevent "CartItems is not defined" error
// This ensures the page doesn't crash even if cart.js loads slowly
// ---------------------------------------------------------
if (typeof CartItems === 'undefined') {
  window.CartItems = class CartItems extends HTMLElement {
    constructor() {
      super();
    }
  };
}

// ---------------------------------------------------------
// START OF CART DRAWER CODE
// ---------------------------------------------------------

if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      // Bind handlers once so we can safely add/remove listeners
      this.onEscapeKey = (evt) => evt.code === 'Escape' && this.close();
      this.onOverlayClick = this.close.bind(this);

      this.addEventListener('keyup', this.onEscapeKey);

      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.onOverlayClick);
      }

      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;

      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');

      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });

      cartLink.addEventListener('keydown', (event) => {
        // Shopify themes often emit "Space" for keyboard activation
        if (String(event.code).toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);

      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
        this.setSummaryAccessibility(cartDrawerNote);
      }

      // Ensure animation triggers consistently
      setTimeout(() => {
        this.classList.add('animate', 'active');
      }, 0);

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');

          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

          if (typeof window.trapFocus === 'function' && containerToTrapFocusOn) {
            window.trapFocus(containerToTrapFocusOn, focusElement);
          }
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');

      if (typeof window.removeTrapFocus === 'function') {
        window.removeTrapFocus(this.activeElement);
      }

      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget.closest('details').hasAttribute('open')
        );
      });

      if (cartDrawerNote.parentElement && typeof window.onKeyUpEscape === 'function') {
        cartDrawerNote.parentElement.addEventListener('keyup', window.onKeyUpEscape);
      }
    }

    renderContents(parsedState) {
      // Defensive guards
      const sections = parsedState && parsedState.sections ? parsedState.sections : {};
      this.classList.remove('is-empty');

      const drawerInner = this.querySelector('.drawer__inner');
      if (drawerInner && drawerInner.classList.contains('is-empty')) {
        drawerInner.classList.remove('is-empty');
      }

      // parsedState.id may not exist depending on which endpoint returned this payload
      if (parsedState && typeof parsedState.id !== 'undefined') {
        this.productId = parsedState.id;
      }

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        const html = sections[section.id];
        if (!sectionElement || !html) return;

        sectionElement.innerHTML = this.getSectionInnerHTML(html, section.selector);
      });

      // Open drawer after render
      setTimeout(() => {
        this.open();
      }, 0);
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const node = doc.querySelector(selector);
      return node ? node.innerHTML : '';
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
          childSectionSelectors: [
            '.drawer__heading',
            '.cart__free-shipping',
            '.drawer__contents',
            '.cart-drawer__footer-info',
          ],
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('cart-drawer-items')) {
  class CartDrawerItems extends CartItems {
    constructor() {
      super();
      this.cartDrawerUpsells = this.querySelector('.cart-drawer-recommendations');
    }

    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.js-contents',
          childSectionSelectors: [
            '.drawer__heading',
            '.cart__free-shipping',
            '.drawer__contents',
            '.cart-drawer__footer-info',
          ],
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }

    closeUpsells(cartDrawerInner) {
      if (!this.cartDrawerUpsells) return;

      this.cartDrawerUpsells.style.transform = 'translate(100%)';
      this.cartDrawerUpsells.addEventListener(
        'transitionend',
        () => {
          if (cartDrawerInner) cartDrawerInner.classList.remove('drawer__inner--no-border');
          this.cartDrawerUpsells.classList.add('close');
        },
        { once: true }
      );
    }

    updateUpsells(cartRecommendationsHtml, cartDrawerInner) {
      if (!this.cartDrawerUpsells) return;

      if (cartRecommendationsHtml === '') {
        this.cartDrawerUpsells.classList.remove('cart-drawer-recommendations--loading');
        this.closeUpsells(cartDrawerInner);
      } else {
        const cartDrawerRecommendationsList = this.cartDrawerUpsells.querySelector('.cart-drawer-recommendations__list');
        if (cartDrawerRecommendationsList) {
          cartDrawerRecommendationsList.classList.add('disable-list');
          if (cartDrawerInner) cartDrawerInner.classList.add('drawer__inner--no-border');
          this.cartDrawerUpsells.classList.remove('close');
        }

        setTimeout(() => {
          this.cartDrawerUpsells.innerHTML = cartRecommendationsHtml;
        }, 200);
      }
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
}

if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          if (this.classList.contains('product-recommendations--loaded')) return;

          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('cart-recommendations');
          const cartDrawerUpsells = this.closest('.cart-drawer-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            if (cartDrawerUpsells) cartDrawerUpsells.classList.remove('cart-drawer-recommendations--loading');

            this.innerHTML = recommendations.innerHTML;

            const cartDrawerRecommendationsList = this.querySelector('.cart-drawer-recommendations__list');
            if (cartDrawerRecommendationsList) {
              setTimeout(() => {
                cartDrawerRecommendationsList.classList.remove('disable-list');
              }, 0);
            }
          }

          const cartDrawerInner = cartDrawerUpsells ? cartDrawerUpsells.closest('.drawer__inner') : null;

          if (!this.querySelector('.cart-drawer-recommendations__list')) {
            if (cartDrawerUpsells) cartDrawerUpsells.classList.add('close');
            setTimeout(() => {
              if (cartDrawerInner) cartDrawerInner.classList.remove('drawer__inner--no-border');
            }, 200);
          } else {
            if (cartDrawerInner) cartDrawerInner.classList.add('drawer__inner--no-border');
            if (cartDrawerUpsells) cartDrawerUpsells.classList.remove('close');
          }

          this.classList.add('product-recommendations--loaded');

          // Re-run scripts for complementary products if present
          if (this.classList.contains('complementary-products')) {
            this.querySelectorAll('script').forEach((oldScriptTag) => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
}